import { translations } from "../../../configs/translations"
import { useStore } from "../../../store/store"

interface Props {
    id: number
    text: string
    raceType: string
    rank: number
    carType: string
    isLeaving?: boolean
    countingDown?: boolean
    countdownKey?: number
    countdownMs?: number
    onAnimationEnd?: (index: number) => void
    onAccept?: () => void
}

export const FreeroamInvite = ({ id, text, raceType, rank, carType, isLeaving, countingDown, countdownKey, countdownMs, onAnimationEnd, onAccept }: Props) => {
    const language = useStore(state => state.language)
    const t = translations[language]

    return (
        <div
            className={`freeroam-invite ${isLeaving ? 'slide-out' : ''}`}
            onAnimationEnd={(e) => {
                if (isLeaving && onAnimationEnd) {
                    onAnimationEnd(id)
                }
            }}
            onClick={() => {
                if (onAccept) {
                    onAccept()
                }
            }}
        >
            <div className="freeroam-invite-content">
                <div className="freeroam-invite-icon">
                    <img style={{ width: "32px", height: "32px" }} src={`./icons/64px/${raceType}.png`} alt={raceType} />
                </div>
                <div className="freeroam-invite-text">
                    <p>{text}</p>
                    <p>
                        <span className="freeroam-invite-text-title">{t.race_type}: </span>
                        {t[raceType as keyof typeof t]}
                    </p>
                    <p>
                        <span className="freeroam-invite-text-title">{t.rank}: </span>
                        {rank}
                    </p>
                    <p>
                        <span className="freeroam-invite-text-title">{t.car_type}: </span>
                        {carType}
                    </p>
                </div>
            </div>
            <div className="freeroam-invite-buttons">
                <div className="freeroam-invite-button">{t.join} (F4)</div>
            </div>
            <div className='freeroam-invite-progress-bar-wrapper'>
                <div
                    key={countingDown ? countdownKey : 'idle'}
                    className={`freeroam-invite-progress-bar ${countingDown ? 'freeroam-invite-progress-bar-countdown' : ''}`}
                    style={countingDown ? { animationDuration: `${countdownMs}ms` } : undefined}
                />
            </div>
        </div>
    )
}